import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import ServerLeasePricing from './components/ServerLeasePricing';

export default function BuyTradelines() {
  const tradelines = [
    // Tier $972.00
    { issuer: 'Barclays', id: '8115', limit: '$21,500.00', opened: '2020 Jan', statement: 'Mar 5th', posting: 'Mar 16th - Mar 23rd', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Barclays', id: '31286', limit: '$16,000.00', opened: '2018 Dec', statement: 'Mar 7th', posting: 'Mar 18th - Mar 25th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Elan', id: '14493', limit: '$21,000.00', opened: '2019 May', statement: 'Mar 22nd', posting: 'Apr 2nd - Apr 9th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '13645', limit: '$21,200.00', opened: '2020 Jun', statement: 'Mar 4th', posting: 'Mar 15th - Mar 22nd', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '24700', limit: '$20,000.00', opened: '2019 Oct', statement: 'Feb 28th', posting: 'Mar 11th - Mar 18th', availability: '1 in stock', price: '$972.00' },
    { issuer: 'CP1', id: '2837', limit: '$11,000.00', opened: '2015 Apr', statement: 'Feb 24th', posting: 'Mar 7th - Mar 14th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '13709', limit: '$21,700.00', opened: '2018 Jun', statement: 'Mar 9th', posting: 'Mar 20th - Mar 27th', availability: '1 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '21016', limit: '$22,775.00', opened: '2020 Dec', statement: 'Feb 21st', posting: 'Mar 4th - Mar 11th', availability: '1 in stock', price: '$972.00' },
    { issuer: 'Elan', id: '26587', limit: '$20,000.00', opened: '2018 Mar', statement: 'Mar 22nd', posting: 'Apr 2nd - Apr 9th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '23590', limit: '$5,500.00', opened: '2007 Jun', statement: 'Mar 22nd', posting: 'Apr 2nd - Apr 9th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Barclays', id: '8116', limit: '$20,000.00', opened: '2020 May', statement: 'Feb 21st', posting: 'Mar 4th - Mar 11th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '31612', limit: '$5,000.00', opened: '2008 Aug', statement: 'Mar 1st', posting: 'Mar 12th - Mar 19th', availability: '1 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '11295', limit: '$20,000.00', opened: '2018 Dec', statement: 'Feb 23rd', posting: 'Mar 6th - Mar 13th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '19828', limit: '$16,000.00', opened: '2017 Apr', statement: 'Feb 28th', posting: 'Mar 11th - Mar 18th', availability: '2 in stock', price: '$972.00' },
    { issuer: 'Chase', id: '24701', limit: '$20,000.00', opened: '2017 Feb', statement: 'Feb 28th', posting: 'Mar 11th - Mar 18th', availability: '1 in stock', price: '$972.00' },
    { issuer: 'Barclays', id: '5018', limit: '$20,600.00', opened: '2019 Jan', statement: 'Mar 13th', posting: 'Mar 24th - Mar 31st', availability: '1 in stock', price: '$972.00' },

    // Tier $850.50
    { issuer: 'Chase', id: '12857', limit: '$20,000.00', opened: '2020 Sep', statement: 'Mar 1st', posting: 'Mar 12th - Mar 19th', availability: '2 in stock', price: '$850.50' },
    { issuer: 'Chase', id: '15697', limit: '$15,500.00', opened: '2019 May', statement: 'Mar 7th', posting: 'Mar 18th - Mar 25th', availability: '2 in stock', price: '$850.50' },
    { issuer: 'CP1', id: '22034', limit: '$22,600.00', opened: '2017 Nov', statement: 'Feb 25th', posting: 'Mar 8th - Mar 15th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Bank of America', id: '6349', limit: '$25,000.00', opened: '2023 Jan', statement: 'Mar 11th', posting: 'Mar 22nd - Mar 29th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Barclays', id: '14396', limit: '$27,300.00', opened: '2022 Aug', statement: 'Mar 9th', posting: 'Mar 20th - Mar 27th', availability: '2 in stock', price: '$850.50' },
    { issuer: 'Chase', id: '28297', limit: '$25,000.00', opened: '2020 Feb', statement: 'Mar 8th', posting: 'Mar 19th - Mar 26th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Chase', id: '29221', limit: '$28,800.00', opened: '2022 May', statement: 'Mar 1st', posting: 'Mar 12th - Mar 19th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'CP1', id: '24542', limit: '$27,000.00', opened: '2022 Mar', statement: 'Mar 2nd', posting: 'Mar 13th - Mar 20th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Chase', id: '12023', limit: '$17,500.00', opened: '2018 Aug', statement: 'Mar 2nd', posting: 'Mar 13th - Mar 20th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Barclays', id: '20175', limit: '$28,000.00', opened: '2022 Apr', statement: 'Feb 26th', posting: 'Mar 9th - Mar 16th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Discover', id: '32540', limit: '$16,500.00', opened: '2019 Feb', statement: 'Feb 28th', posting: 'Mar 11th - Mar 18th', availability: '1 in stock', price: '$850.50' },
    { issuer: 'Chase', id: '26761', limit: '$23,400.00', opened: '2021 Dec', statement: 'Mar 23rd', posting: 'Apr 3rd - Apr 10th', availability: '1 in stock', price: '$850.50' },

    // Tier $891.00
    { issuer: 'CP1', id: '15592', limit: '$5,300.00', opened: '2012 Jul', statement: 'Mar 13th', posting: 'Mar 24th - Mar 31st', availability: '2 in stock', price: '$891.00' },
    { issuer: 'Barclays', id: '20899', limit: '$7,700.00', opened: '2014 Dec', statement: 'Mar 1st', posting: 'Mar 12th - Mar 19th', availability: '5 in stock', price: '$891.00' },
    { issuer: 'CP1', id: '31342', limit: '$5,000.00', opened: '2012 Jan', statement: 'Feb 22nd', posting: 'Mar 5th - Mar 12th', availability: '1 in stock', price: '$891.00' },
    { issuer: 'CP1', id: '27891', limit: '$5,500.00', opened: '2013 May', statement: 'Mar 5th', posting: 'Mar 16th - Mar 23rd', availability: '2 in stock', price: '$891.00' },

    // Higher Tiers
    { issuer: 'CP1', id: '23279', limit: '$45,000.00', opened: '2015 May', statement: 'Mar 15th', posting: 'Mar 26th - Apr 2nd', availability: '1 in stock', price: '$1,458.00' },
    { issuer: 'Chase', id: '30244', limit: '$25,000.00', opened: '2011 Feb', statement: 'Mar 11th', posting: 'Mar 22nd - Mar 29th', availability: '2 in stock', price: '$1,539.00' },
    { issuer: 'Elan', id: '10847', limit: '$25,000.00', opened: '2008 Nov', statement: 'Mar 17th', posting: 'Mar 28th - Apr 4th', availability: '2 in stock', price: '$1,539.00' },
    { issuer: 'Elan', id: '25176', limit: '$25,000.00', opened: '2010 Feb', statement: 'Mar 22nd', posting: 'Apr 2nd - Apr 9th', availability: '1 in stock', price: '$1,539.00' },
    { issuer: 'Chase', id: '15368', limit: '$25,000.00', opened: '2006 Dec', statement: 'Mar 16th', posting: 'Mar 27th - Apr 3rd', availability: '2 in stock', price: '$1,539.00' },
    { issuer: 'Chase', id: '21262', limit: '$27,600.00', opened: '2007 Jan', statement: 'Feb 25th', posting: 'Mar 8th - Mar 15th', availability: '2 in stock', price: '$1,539.00' },
    { issuer: 'CP1', id: '12866', limit: '$30,000.00', opened: '2015 Jun', statement: 'Feb 25th', posting: 'Mar 8th - Mar 15th', availability: '1 in stock', price: '$1,701.00' },
    { issuer: 'Chase', id: '27387', limit: '$30,800.00', opened: '2014 Jun', statement: 'Feb 27th', posting: 'Mar 10th - Mar 17th', availability: '2 in stock', price: '$1,701.00' },
    { issuer: 'Chase', id: '6494', limit: '$31,000.00', opened: '2016 Mar', statement: 'Mar 14th', posting: 'Mar 25th - Apr 1st', availability: '2 in stock', price: '$1,701.00' },
    { issuer: 'Chase', id: '15709', limit: '$30,600.00', opened: '2013 Dec', statement: 'Feb 21st', posting: 'Mar 4th - Mar 11th', availability: '1 in stock', price: '$1,701.00' },
    { issuer: 'Chase', id: '30009', limit: '$33,000.00', opened: '2014 Aug', statement: 'Feb 27th', posting: 'Mar 10th - Mar 17th', availability: '1 in stock', price: '$1,701.00' },
    { issuer: 'Discover', id: '32114', limit: '$30,800.00', opened: '2016 Jul', statement: 'Feb 28th', posting: 'Mar 11th - Mar 18th', availability: '1 in stock', price: '$1,701.00' },
    { issuer: 'Chase', id: '30954', limit: '$30,100.00', opened: '2014 Aug', statement: 'Mar 12th', posting: 'Mar 23rd - Mar 30th', availability: '1 in stock', price: '$1,701.00' },
  ];

  const businessCreditFeatures = [
    {
      icon: 'ri-building-line',
      title: 'ERP & Cloud Server Lease Credit Builder',
      description: 'A structured lease-based tradeline designed specifically for business credit development.'
    },
    {
      icon: 'ri-funds-line',
      title: 'Reporting Credit Limits up to $150,000',
      description: 'Tradelines structured to support meaningful reported limits for stronger fundability signals.'
    },
    {
      icon: 'ri-file-chart-line',
      title: 'Positive Reporting to Business Bureaus',
      description: 'Payments are reported to SBFE and applicable business credit bureaus to build business credit history.'
    }
  ];

  const businessCreditBenefits = [
    'Establish business credit with major business credit bureaus',
    'Add positive financial business tradelines',
    'Improve lending profile and fundability',
    'Qualify for better rates and terms',
    'Increase approval odds for business credit products',
    'Support higher business credit limits over time'
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="pt-20">
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
            <p className="text-xs uppercase tracking-wider text-gray-600 mb-4 font-semibold">
              TRADELINE INVENTORY
            </p>
            <h1 className="text-5xl md:text-6xl font-bold text-navy mb-6">
              Buy Tradelines
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Authorized User Tradelines and Credit Profile Placement Options
            </p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-navy text-white">
                    <th className="px-4 py-3 text-left text-sm font-semibold">Issuer</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">ID</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Credit Limit</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Opened</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Statement Date</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Posting Window</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Availability</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold">Price</th>
                  </tr>
                </thead>
                <tbody>
                  {tradelines.map((line, index) => (
                    <tr
                      key={line.id ?? index}
                      className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-100 transition-colors`}
                    >
                      <td className="px-4 py-3 text-sm text-gray-900">{line.issuer}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{line.id}</td>
                      <td className="px-4 py-3 text-sm text-gray-900 font-medium">{line.limit}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{line.opened}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{line.statement}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{line.posting}</td>
                      <td className="px-4 py-3 text-sm text-gray-700">{line.availability}</td>
                      <td className="px-4 py-3 text-sm text-navy font-semibold">{line.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-16">
              <p className="text-xs uppercase tracking-wider text-gray-600 mb-4 font-semibold">
                BUSINESS CREDIT
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6">
                Business Credit
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Build strong, fundable business credit using structured, reportable business tradelines.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-12">
              <h3 className="text-2xl font-bold text-navy mb-4">
                Server Lease Builder
              </h3>
              <p className="text-base text-gray-600 leading-relaxed mb-8">
                Server Lease Builder is a structured business tradeline designed to help establish and strengthen your business credit profile. Payments are reported to SBFE and applicable business credit bureaus to support long-term fundability and lender readiness.
              </p>

              <h4 className="text-xl font-semibold text-navy mb-6">
                How Server Lease Builder Helps
              </h4>
              <ul className="space-y-3 mb-10">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-navy mt-0.5"></i>
                  <span className="text-sm text-gray-700">Adds a reportable business tradeline to your business credit profile</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-navy mt-0.5"></i>
                  <span className="text-sm text-gray-700">Builds positive payment history with consistent reporting</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-navy mt-0.5"></i>
                  <span className="text-sm text-gray-700">Strengthens overall fundability and lender confidence</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-navy mt-0.5"></i>
                  <span className="text-sm text-gray-700">Improves approval odds for business funding products</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-xl text-navy mt-0.5"></i>
                  <span className="text-sm text-gray-700">Supports higher business credit limits over time</span>
                </li>
              </ul>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
                {businessCreditFeatures.map((feature, index) => (
                  <div key={index} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                    <div className="w-12 h-12 flex items-center justify-center mb-4">
                      <i className={`${feature.icon} text-3xl text-navy`}></i>
                    </div>
                    <h5 className="text-base font-semibold text-navy mb-3">
                      {feature.title}
                    </h5>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>

              <h4 className="text-xl font-semibold text-navy mb-6">
                Business Credit Benefits
              </h4>
              <ul className="space-y-3 mb-8">
                {businessCreditBenefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-line text-xl text-navy mt-0.5"></i>
                    <span className="text-sm text-gray-700">{benefit}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-4 justify-center">
                <Link
                  to="/apply"
                  className="inline-flex items-center bg-navy text-white px-8 py-4 rounded-lg text-base font-medium hover:bg-navy/90 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Started
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          </div>
        </section>

        <ServerLeasePricing />

        <section className="py-24 bg-navy text-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold mb-6">
              Ready to Strengthen Your Profile?
            </h2>
            <p className="text-lg text-gray-300 mb-10">
              Contact us to discuss which tradelines are right for your funding strategy
            </p>
            <Link
              to="/apply"
              className="inline-flex items-center bg-white text-navy px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Apply Now
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
